interface Props {
  className?: string;
}
export const ParagraphIcon = ({ className }: Props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="521.000000pt"
      height="521.000000pt"
      viewBox="0 0 521.000000 521.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <metadata>Created by potrace 1.14, written by Peter Selinger 2001-2017</metadata>
      <g
        transform="translate(0.000000,521.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none"
      >
        <path
          d="M140 3350 l0 -1750 514 0 c317 0 517 4 521 10 3 5 12 7 19 4 22 -8
    316 -10 316 -2 0 4 6 5 13 2 8 -3 27 -6 43 -7 23 -2 29 -7 28 -25 0 -12 3 -22
    7 -22 4 0 4 -13 -1 -29 -4 -15 -4 -34 0 -42 5 -7 5 -20 0 -29 -5 -9 -5 -22 -1
    -28 4 -7 5 -35 1 -62 -4 -27 -3 -55 1 -62 4 -6 4 -19 -1 -28 -5 -9 -5 -22 0
    -30 5 -8 5 -21 0 -30 -5 -9 -5 -22 0 -30 4 -7 4 -24 0 -36 -6 -14 -5 -26 0
    -29 5 -3 5 -18 0 -35 -5 -17 -5 -30 0 -30 5 0 5 -13 0 -30 -5 -17 -5 -30 0
    -30 5 0 5 -13 0 -30 -5 -16 -6 -30 -2 -30 4 0 7 -16 7 -35 0 -19 -3 -35 -7
    -35 -4 0 -3 -13 2 -30 5 -16 5 -30 0 -30 -4 0 -5 -12 -1 -27 4 -16 4 -44 1
    -65 -4 -20 -4 -42 1 -49 4 -7 4 -20 -1 -29 -5 -9 -5 -22 0 -30 5 -8 5 -21 0
    -30 -5 -9 -5 -22 0 -30 4 -7 4 -24 0 -36 -6 -14 -5 -26 0 -29 5 -3 5 -18 0
    -35 -5 -17 -5 -30 0 -30 5 0 5 -13 0 -30 -5 -17 -5 -30 0 -30 5 0 5 -13 0 -30
    -5 -16 -6 -30 -2 -30 8 0 7 -68 -1 -76 -3 -3 -2 -16 3 -29 5 -13 6 -26 3 -29
    -4 -3 780 -6 1740 -6 l1747 0 0 1840 0 1840 -175 0 -175 0 0 -1667 0 -1668
    -672 3 c-370 1 -774 2 -898 1 -124 0 -232 -1 -240 -1 -8 1 -228 1 -487 1
    l-473 1 0 550 0 551 33 -1 c17 0 55 0 84 1 29 0 57 -2 62 -5 5 -4 12 -2 16 4
    4 6 11 8 16 4 9 -5 373 -7 449 -1 19 1 45 -1 57 -5 12 -4 25 -3 28 3 4 5 11 7
    16 3 6 -3 34 -6 62 -5 29 1 62 1 75 1 46 0 218 30 287 50 70 21 87 25 115 32
    8 1 17 5 20 8 3 3 41 23 84 44 85 40 173 97 219 140 15 14 31 26 35 27 12 1
    115 128 156 192 43 66 115 238 116 273 0 11 3 24 7 28 4 4 8 24 9 45 0 21 4
    44 9 51 16 26 9 349 -10 435 -9 44 -18 87 -20 95 -2 13 -14 47 -32 90 -3 8 -7
    20 -7 25 -3 22 -67 134 -110 191 -138 185 -402 351 -631 400 -179 38 -176 37
    -851 41 l-662 4 -4 -30 c-3 -17 -1 -31 3 -31 4 0 4 -13 -1 -30 -5 -17 -5 -30
    0 -30 5 0 5 -13 0 -30 -5 -17 -5 -30 0 -30 5 0 5 -13 0 -29 -4 -15 -4 -34 0
    -42 5 -7 5 -20 0 -29 -5 -9 -5 -22 0 -30 5 -8 5 -21 0 -30 -5 -9 -5 -22 0 -30
    5 -8 5 -21 0 -31 -5 -9 -7 -19 -3 -22 7 -8 8 -106 0 -113 -3 -3 -1 -19 3 -35
    5 -16 5 -31 0 -34 -4 -3 -4 -20 0 -39 4 -19 4 -40 0 -46 -4 -7 -4 -25 0 -41 5
    -15 5 -30 2 -34 -8 -7 -5 -102 3 -115 3 -6 2 -10 -4 -10 -6 0 -6 -11 -1 -30 5
    -17 5 -30 0 -30 -5 0 -5 -13 0 -30 5 -17 5 -30 0 -30 -5 0 -5 -13 0 -30 5 -17
    5 -30 0 -30 -5 0 -5 -13 0 -30 5 -17 5 -30 0 -30 -5 0 -5 -13 0 -30 5 -17 5
    -30 0 -30 -5 0 -5 -13 0 -30 5 -17 5 -30 0 -30 -5 0 -5 -13 0 -30 5 -17 5 -30
    0 -30 -5 0 -5 -13 0 -30 5 -17 5 -30 0 -30 -5 0 -7 -6 -4 -14 9 -24 10 -79 2
    -103 -10 -31 13 -45 74 -44 124 3 148 2 157 -3 5 -4 12 -2 15 3 4 5 18 6 32 2
    15 -4 42 -5 60 -3 l34 4 -2 595 -3 595 465 -5 c453 -5 542 -11 588 -40 6 -5
    12 -6 12 -3 0 10 114 -35 169 -66 179 -100 282 -233 332 -428 28 -107 27 -315
    -1 -424 -27 -107 -82 -216 -141 -278 -27 -29 -49 -56 -49 -60 0 -4 -6 -8 -13
    -8 -7 0 -22 -8 -33 -18 -19 -16 -32 -24 -98 -61 -48 -27 -143 -61 -236 -84
    -83 -20 -109 -21 -1277 -24 l-1193 -4 0 1410 0 1411 1665 0 1665 0 0 170 0
    170 -1840 0 -1840 0 0 -1750z"
        />
        <path
          d="M4180 4930 l0 -170 280 0 280 0 0 -280 0 -280 175 0 175 0 0 450 0
    450 -455 0 -455 0 0 -170z"
        />
      </g>
    </svg>
  );
};
